export default __webpack_public_path__ + "static/media/typeBicycle.58bcd48e.svg";